import RESTClient from 'web-app/api/clients/rest-client-famly-app';

export const getCSVLink = (institutionId, csvType, from, to) =>
    RESTClient.getAuthenticatedObservable(
        `v2/reports/${csvType}/csv/generate?institutionId=${institutionId}&from=${from}&to=${to}`,
    );
